<script setup lang="ts">
import { useAttrs, computed } from 'vue'
import { avatars } from '@/constants'
import AvatarSvg from '@/assets/avatar.svg'

const attrs = useAttrs()
const props = defineProps<{
  id?: number
  src?: string
  active?: boolean
  tag?: string
}>()

const baseAvatar = computed(() => avatars.find((el) => Number(el.id) === Number(props.id)))
</script>

<template>
  <div class="avatar" :class="{ 'avatar--active': active, 'avatar--clickable': attrs.onClick }">
    <img v-if="src" class="avatar__inner" :src="props.src" :alt="`Avatar ${id}`" />
    <img v-else-if="baseAvatar" class="avatar__inner" :src="baseAvatar.url" :alt="`Avatar ${id}`" />
    <AvatarSvg v-else class="avatar__inner" />

    <div v-if="tag" class="avatar__tag">
      {{ tag }}
    </div>
  </div>
</template>

<style lang="scss">
.avatar {
  border-radius: 50%;
  position: relative;

  &--clickable {
    cursor: pointer;
  }

  &--active {
    outline: solid #2b63f3 2px;
    padding: 4px;
  }

  &__inner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    user-select: none;
    -webkit-user-drag: none;
  }

  &__tag {
    position: absolute;
    bottom: -5px;
    left: -5px;
    background-color: #675caf;
    color: #fff;
    padding: 3px 4px;
    border-radius: 25px;
    font-size: 0.5rem;
    font-weight: 600;
    line-height: 0.5rem;
    z-index: 1;
  }
}
</style>
